import { Hospital } from 'lucide-react'
import { useMemo, useState } from 'react'

import FilterManagementDropdown from 'components/brokers/needs_attention/FilterManagementDropdown'
import { filterByLabelAndValueCallback } from 'components/brokers/needs_attention/utils'
import { type MultipleSelectedValuesFilter } from 'components/brokers/types'
import { useGetInsuranceCarriers } from 'components/hooks/needs_attention/useGetInsuranceCarriers'
import ComboboxMultiSelectFilter, {
  type ComboboxFilterOption,
} from 'components/reusable/table/ComboboxMultiSelectFilter'

const CarrierNameFilter = (props: MultipleSelectedValuesFilter) => {
  const [query, setQuery] = useState('')

  const { data: carriers } = useGetInsuranceCarriers()

  const carrierOptions: ComboboxFilterOption<string>[] | undefined = useMemo(
    () =>
      carriers
        ?.map((carrier) => ({
          label: carrier.carrier_name,
          value: carrier.carrier_name,
        }))
        .sort((a, b) => a.label.localeCompare(b.label)),
    [carriers]
  )

  const filteredOptions = useMemo(
    () => carrierOptions?.filter(filterByLabelAndValueCallback(query)),
    [carrierOptions, query]
  )

  // Ensure selectedValues is always an array
  const selectedValues = props.selectedValues || []

  return (
    <div>
      <ComboboxMultiSelectFilter
        {...props}
        selectedValues={selectedValues}
        options={[
          { groupLabel: 'Carrier names', options: filteredOptions || [] },
        ]}
        placeholder='Search carriers to filter...'
        onValueChange={setQuery}
      >
        <button
          type='button'
          className='w-full'
          style={{ all: 'unset', cursor: 'pointer' }}
        >
          <FilterManagementDropdown
            {...props}
            selectedValues={selectedValues}
            options={carrierOptions || []}
            noSelectionText='Carrier Name'
            pluralIdentifier='carriers'
          >
            <Hospital size={20} />
          </FilterManagementDropdown>
        </button>
      </ComboboxMultiSelectFilter>
    </div>
  )
}

export default CarrierNameFilter
